<template>
  <svg
    :class="$options.name"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 331.945 276.747"
  >
    <title id="ETlogo" lang="en">ET logo</title>
    <g id="Group_559" data-name="Group 559" transform="translate(-27.277 -19)">
      <rect
        id="Rectangle_2145"
        data-name="Rectangle 2145"
        class="cls-1"
        width="148.351"
        height="40.759"
        transform="translate(27.286 19)"
      />
      <path
        id="Union_4"
        data-name="Union 4"
        class="cls-2"
        d="M217.648,200.014V40.756H0V0H331.941V40.756H260.629V200.014Z"
        transform="translate(27.281 95.733)"
      />
      <rect
        id="Rectangle_2146"
        data-name="Rectangle 2146"
        class="cls-3"
        width="147.965"
        height="40.759"
        transform="translate(27.286 174.845)"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'ETLogo',
  props: {
    width: {
      type: [Number, String],
      default: 30,
    },
    height: {
      type: [Number, String],
      default: 30,
    },
  },
}
</script>

<style lang="scss" scoped>
.ETLogo {
  margin-left: 50px;
  @include mobile {
    margin: 0px;
  }
}

.cls-1,
.cls-3 {
  fill: #fcc987;
}

.cls-3 {
  opacity: 0.24;
}

.cls-2 {
  fill: #ffff;
}

.cls-3 {
  opacity: 0.61;
}
</style>
